var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.update)?_c('Masonry',{attrs:{"title":"行业精选","category_path":"industry","category_id":_vm.categoryID}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }